import { h } from 'preact';

import actions from '../store/actions';
import { connect } from 'redux-zero/preact';
import { $lang } from '../plugins/helper';

const mapToProps = ({
    type,
  }) => ({ type });

const CompleteLayout = (props) => (
    <div className="et-container et-px-4 et-mx-auto">
        <div>
            {
                props.type == 'pt' ?
                <div className="et-text-center">
                    <h2 className="et-text-2xl et-font-bold">{$lang('finish_test')}</h2>
                    <p className="et-py-4">
                        {$lang('finish_test_question')}
                    </p>
                </div>
                :
                <p className="et-py-4 et-text-center">{props.title}</p>
            }
            <div className="et-flex et-justify-center">
                {
                    props.type == 'pt' &&
                    <button onClick={() => props.handleModal(true)} className="et-result-btn start-over et-bg-indigo-400">
                        {$lang('button.start_over')}
                    </button>
                }
                <button onClick={() => props.submitQuestion()} className="et-bg-blue-400 et-result-btn submit">
                    {$lang('button.submit')}
                </button>
            </div>
        </div>
    </div>
);

export default connect(mapToProps, actions)(CompleteLayout)